import * as React from "react";
import { genBlock } from "@/utils/bem";
import "./style.less";

interface Card {
  img: string;
  title: string;
  desc: string | React.ReactNode;
  linkText?: string;
  linkClick?: string | (() => void);
}

interface HorizontalCardProps {
  title?: string;
  cards?: Card[];
  className?: string;
  style?: React.CSSProperties;
}

const block = genBlock("horizontal-card");

/**
 * @example
 * title?: string;
 * cards?: Card[];
 * // Card
 * img: string;
 * title: string;
 * desc: string | React.ReactNode;
 * linkText?: string;
 * linkClick?: string | (() => void);
 */
export const HorizontalCards: React.FC<HorizontalCardProps> = ({
  title = "",
  cards = [],
  className = "",
  style = {},
}) => {
  const handleCardLink = (index) => {
    if (typeof cards[index].linkClick === "string") {
      /* eslint-disable no-new */
      window.location.href = cards[index].linkClick as string;
    }

    if (typeof cards[index].linkClick === "function") {
      (cards[index].linkClick as () => void)();
    }
  };

  return (
    <div className={`${block()} ${className}`} style={style}>
      <div className={block("title")}>{title}</div>
      <div className={block("wrap")}>
        {cards.map((item, index) => (
          <div
            className={block("card")}
            key={index}
            onClick={() => handleCardLink(index)}
          >
            <img src={item.img} alt="" className={block("card-img")} />
            <div className={block("card-info")}>
              <p className={block("card-title")}>{item.title}</p>
              <p className={block("card-desc")}>{item.desc}</p>
              {item.linkText && (
                <p className={block("card-link")}>
                  {item.linkText}
                  <span className={block("card-link-arrow")}>→</span>
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
